import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { GetDetail, Update } from '../web_api/api'
import '../branch/branch.css'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';

export default function CmsTreatmentUpdate() {
    const location = useLocation()
    const ID = location.pathname.split('/')[2]
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [imageFile, setImageFile] = useState(null)
    const [existingImage, setExistingImage] = useState('')
    const [detailData, setDetailData] = useState(null)

    const handleImage = (e) => {
        if (e.target.files[0]) setImageFile(e.target.files[0])
    }

    const update = async () => {
        const formData = new FormData()
        formData.append('name', name)
        formData.append('description', description)
        if (imageFile) {
            formData.append('image', imageFile)
        } else {
            formData.append('image', detailData?.image)
        }
        await Update('cms-treatment-type/', ID, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
        setImageFile(null)
    }

    useEffect(() => {
        const fetchDetail = async () => {
            try {
                const res = await GetDetail('cms-treatment-type/', ID)
                const data = res.data || res
                setDetailData(data)
                setName(data.name || '')
                setDescription(data.description || '')
                if (data.image) setExistingImage(data.image)
            } catch (err) {
                console.error(err)
            }
        }
        fetchDetail()
    }, [ID])

    const previewUrl = imageFile ? URL.createObjectURL(imageFile) : existingImage

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/cms-treatment'>Treatment Types</Link>
                <span className='separator'>/</span>
                <span className='current'>Update Treatment Type</span>
            </div>

            <div className='branch-page-title'>Update Treatment Type</div>
            <div className='branch-page-subtitle'>Edit treatment type details</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Treatment Information</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='name'>Name</label>
                                    <input type='text' id='name' placeholder='Treatment Type Name' className='branch-input' value={name} onChange={(e) => setName(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='desc'>Description</label>
                                    <textarea id='desc' placeholder='Write description ...' className='branch-input' value={description} onChange={(e) => setDescription(e.target.value)} />
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Image</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='img'>Upload Image</label>
                                    <input type='file' id='img' className='branch-input' onChange={handleImage} />
                                    {previewUrl && (
                                        <div className='branch-preview-grid'>
                                            <div className='branch-preview-item' style={{ width: '200px', height: '150px' }}>
                                                <PhotoProvider>
                                                    <PhotoView src={previewUrl}>
                                                        <img src={previewUrl} alt='preview' style={{cursor: 'pointer', width: '100%', height: '100%', objectFit: 'cover'}} />
                                                    </PhotoView>
                                                </PhotoProvider>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='branch-form-footer'>
                        <Link to='/cms-treatment' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={update}>Update</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
